import { compose, hoistStatics, lifecycle, withHandlers, withState, withProps } from 'recompose';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import FeedbackSimple from './FeedbackSimple';
import WithLoading from '../../../../../components/WithLoading';
import FeedbackService from '../../../../../services/feedback.service';
import UserService from '../../../../../services/user.service';
import VoteService from '../../../../../services/vote.service';

const voteForFeedback = props => async (e, id, count) => {
  e.preventDefault();
  if (!props.user) {
    return props.history.push('/login');
  }
  const { setVoteStatus, setVote, vote, isSubmitting, setIsSubmitting } = props;
  if (!isSubmitting) {
    setIsSubmitting(true);
    const resp = await VoteService.addVote({ model_id: id, model_name: FeedbackService.modelName });
    if (resp) {
      setVoteStatus(count);
      setVote(count ? vote - 1 : vote + 1);
    }
    setIsSubmitting(false);
  }
};

const createBody = (props, len) => {
  const HasBody = props.item.body && props.item.body.length;
  let newString = props.item.body;
  if (HasBody && HasBody > len) newString = `${props.item.body.substring(0, len)}...`;
  return props.simple ? newString : props.item.body;
};

const mapStateToProps = state => ({
  backgroundColor: state.settings.backgroundPage,
  user: state.user.user,
});

const enhance = compose(
  connect(mapStateToProps, null),
  translate('portal'),
  withState('isLoading', 'setIsLoading', true),
  withState('searchPost', 'setSearchPost', null),
  withState('voteStatus', 'setVoteStatus', props => !props.item.voted),
  withState('vote', 'setVote', props => props.item.votes),
  withState('isSubmitting', 'setIsSubmitting', false),
  withProps(props => ({
    status: FeedbackService.getStatusList(props.t)[props.item.status],
    imgSrc: UserService.getAvatar({ avatar_url: props.item.creator_avatar_url, filename: props.item.creator_avatar }, 150, 150),
    body: createBody(props, 170),
  })),
  lifecycle({
    async componentDidMount() {
      const { setIsLoading } = this.props;
      setIsLoading(false);
    },
  }),
  withHandlers({
    voteForFeedback,
  }),
);

export default withRouter(hoistStatics(enhance)(WithLoading(FeedbackSimple)));



// WEBPACK FOOTER //
// ./src/views/modules/feedback/feedbackItem/simple/index.js